<template>
  <div class="postname-rules">
    <div class="header">
      <h2>岗位词规则管理</h2>
      <div class="header-buttons">
        <el-button type="success" icon="el-icon-refresh" @click="refreshData">刷新</el-button>
        <el-button type="primary" @click="addRule">添加规则</el-button>
      </div>
    </div>

    <!-- 表格 -->
    <div class="table-container">
      <el-table
        :data="tableData"
        v-loading="loading"
        border
        style="width: 100%"
        :header-cell-style="{ background: '#f5f7fa' }"
      >
        <el-table-column prop="id" label="ID" width="40" align="center"></el-table-column>
        
        <!-- 条件列 -->
        <el-table-column label="岗位词关键词1" width="130" align="center">
          <template slot-scope="scope">
            <div class="condition-cell">
              <el-input
                v-model="scope.row.p1"
                type="textarea"
                :rows="2"
                placeholder="请输入关键词，多个用逗号分隔"
                size="small"
              ></el-input>
              <el-select v-model="scope.row.p1s" size="mini" style="margin-top: 5px; width: 100%">
                <el-option label="等于" value="1"></el-option>
                <el-option label="不等" value="2"></el-option>
                <el-option label="不管" value="3"></el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="岗位词关键词2" width="130" align="center">
          <template slot-scope="scope">
            <div class="condition-cell">
              <el-input
                v-model="scope.row.p2"
                type="textarea"
                :rows="2"
                placeholder="请输入关键词，多个用逗号分隔"
                size="small"
              ></el-input>
              <el-select v-model="scope.row.p2s" size="mini" style="margin-top: 5px; width: 100%">
                <el-option label="等于" value="1"></el-option>
                <el-option label="不等" value="2"></el-option>
                <el-option label="不管" value="3"></el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="职位关键词1" width="130" align="center">
          <template slot-scope="scope">
            <div class="condition-cell">
              <el-input
                v-model="scope.row.j1"
                type="textarea"
                :rows="2"
                placeholder="请输入关键词，多个用逗号分隔"
                size="small"
              ></el-input>
              <el-select v-model="scope.row.j1s" size="mini" style="margin-top: 5px; width: 100%">
                <el-option label="等于" value="1"></el-option>
                <el-option label="不等" value="2"></el-option>
                <el-option label="不管" value="3"></el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="职位关键词2" width="130" align="center">
          <template slot-scope="scope">
            <div class="condition-cell">
              <el-input
                v-model="scope.row.j2"
                type="textarea"
                :rows="2"
                placeholder="请输入关键词，多个用逗号分隔"
                size="small"
              ></el-input>
              <el-select v-model="scope.row.j2s" size="mini" style="margin-top: 5px; width: 100%">
                <el-option label="等于" value="1"></el-option>
                <el-option label="不等" value="2"></el-option>
                <el-option label="不管" value="3"></el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="R1-R4关键词1" width="130" align="center">
          <template slot-scope="scope">
            <div class="condition-cell">
              <el-input
                v-model="scope.row.r1"
                type="textarea"
                :rows="2"
                placeholder="请输入关键词，多个用逗号分隔"
                size="small"
              ></el-input>
              <el-select v-model="scope.row.r1s" size="mini" style="margin-top: 5px; width: 100%">
                <el-option label="等于" value="1"></el-option>
                <el-option label="不等" value="2"></el-option>
                <el-option label="不管" value="3"></el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="R1-R4关键词2" width="130" align="center">
          <template slot-scope="scope">
            <div class="condition-cell">
              <el-input
                v-model="scope.row.r2"
                type="textarea"
                :rows="2"
                placeholder="请输入关键词，多个用逗号分隔"
                size="small"
              ></el-input>
              <el-select v-model="scope.row.r2s" size="mini" style="margin-top: 5px; width: 100%">
                <el-option label="等于" value="1"></el-option>
                <el-option label="不等" value="2"></el-option>
                <el-option label="不管" value="3"></el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>

        <!-- 输出列 -->
        <el-table-column label="岗位词输出" width="130" align="center">
          <template slot-scope="scope">
            <div class="output-cell">
              <el-input
                v-model="scope.row.p"
                type="textarea"
                :rows="2"
                placeholder="请输入输出关键词，多个用逗号分隔"
                size="small"
              ></el-input>
              <el-select v-model="scope.row.ps" size="mini" style="margin-top: 5px; width: 100%">
                <el-option label="替换" value="1"></el-option>
                <el-option label="增加" value="2"></el-option>
                <el-option label="清空" value="3"></el-option>
                <el-option label="不管" value="4"></el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="职位输出" width="130" align="center">
          <template slot-scope="scope">
            <div class="output-cell">
              <el-input
                v-model="scope.row.j"
                type="textarea"
                :rows="2"
                placeholder="请输入输出关键词，多个用逗号分隔"
                size="small"
              ></el-input>
              <el-select v-model="scope.row.js" size="mini" style="margin-top: 5px; width: 100%">
                <el-option label="替换" value="1"></el-option>
                <el-option label="增加" value="2"></el-option>
                <el-option label="清空" value="3"></el-option>
                <el-option label="不管" value="4"></el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="R4输出" width="130" align="center">
          <template slot-scope="scope">
            <div class="output-cell">
              <el-input
                v-model="scope.row.r4"
                type="textarea"
                :rows="2"
                placeholder="请输入输出关键词，多个用逗号分隔"
                size="small"
              ></el-input>
              <el-select v-model="scope.row.r4s" size="mini" style="margin-top: 5px; width: 100%">
                <el-option label="替换" value="1"></el-option>
                <el-option label="增加" value="2"></el-option>
                <el-option label="清空" value="3"></el-option>
                <el-option label="不管" value="4"></el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="R3输出" width="120" align="center">
          <template slot-scope="scope">
            <div class="output-cell">
              <el-input
                v-model="scope.row.r5"
                type="textarea"
                :rows="2"
                placeholder="请输入输出关键词，多个用逗号分隔"
                size="small"
              ></el-input>
              <el-select v-model="scope.row.r5s" size="mini" style="margin-top: 5px; width: 100%">
                <el-option label="替换" value="1"></el-option>
                <el-option label="增加" value="2"></el-option>
                <el-option label="清空" value="3"></el-option>
                <el-option label="不管" value="4"></el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="saveRule(scope.row)">保存</el-button>
            <el-button type="danger" size="mini" @click="deleteRule(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <!-- 规则说明 -->
    <div class="rules-explanation" v-show="false">
      <h3>规则说明：</h3>
      <ol>
        <li>黑框是条件，绿框是输出结果，不限字数</li>
        <li>每个黑框后面有3个选项：等于(任意)，不等(任意)，不管</li>
        <li>每个绿框后面有4个选项：替换(原数据)，增加(在原数据基础上新增)，清空(原数据)，不管</li>
        <li>黑框彼此之间是【且】的关系</li>
        <li>最终"增加"后的数据做【去重】处理</li>
        <li>可无限添加，至少1000行</li>
      </ol>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PostnameRules',
  data() {
    return {
      loading: false,
      allData: [], // 存储所有数据
      tableData: [], // 当前页显示的数据
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableName: 'postname_rules'
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    // 获取数据
    async getData() {
      this.loading = true
      try {
        const response = await this.$api.crudselectListByMap({
          table: this.tableName,
          params: {
           
          }
        })
        
        if (response.data && response.data.result === 1) {
          this.allData = response.data.data || []
          this.total = this.allData.length
          this.updateTableData()
        } else {
          this.$message.error('获取数据失败')
        }
      } catch (error) {
        console.error('获取数据失败:', error)
        this.$message.error('获取数据失败')
      } finally {
        this.loading = false
      }
    },

    // 更新当前页显示的数据
    updateTableData() {
      const startIndex = (this.currentPage - 1) * this.pageSize
      const endIndex = startIndex + this.pageSize
      this.tableData = this.allData.slice(startIndex, endIndex)
    },

    // 刷新数据
    async refreshData() {
      this.currentPage = 1
      await this.getData()
      this.$message.success('刷新成功')
    },

    // 添加规则
    addRule() {
      const newRule = {
        p1: '',
        p1s: '3',
        p2: '',
        p2s: '3',
        j1: '',
        j1s: '3',
        j2: '',
        j2s: '3',
        r1: '',
        r1s: '3',
        r2: '',
        r2s: '3',
        p: '',
        ps: '4',
        j: '',
        js: '4',
        r4: '',
        r4s: '4',
        r5: '',
        r5s: '4'
      }
      this.allData.unshift(newRule)
      this.total = this.allData.length
      this.updateTableData()
    },

    // 保存规则
    async saveRule(row) {
      try {
        let response
        if (row.id) {
          // 更新
          response = await this.$api.crudupdatebyid({
            table: this.tableName,
            id: row.id,
            values: row
          })
        } else {
          // 新增
          response = await this.$api.crudInsert({
            table: this.tableName,
            values: row
          })
        }

        if (response.data && response.data.result === 1) {
          this.$message.success('保存成功')
          this.getData() // 重新获取数据以获取新ID
        } else {
          this.$message.error('保存失败')
        }
      } catch (error) {
        console.error('保存失败:', error)
        this.$message.error('保存失败')
      }
    },

    // 删除规则
    async deleteRule(row) {
      if (!row.id) {
        // 如果是新添加的规则，直接从数组中移除
        const index = this.allData.indexOf(row)
        if (index > -1) {
          this.allData.splice(index, 1)
          this.total = this.allData.length
          this.updateTableData()
        }
        return
      }

      this.$confirm('确定要删除这条规则吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await this.$api.crudDeletebyid({
            table: this.tableName,
            id: row.id,
          })

          if (response.data && response.data.result === 1) {
            this.$message.success('删除成功')
            this.getData()
          } else {
            this.$message.error('删除失败')
          }
        } catch (error) {
          console.error('删除失败:', error)
          this.$message.error('删除失败')
        }
      }).catch(() => {
        // 用户取消删除
      })
    },

    // 分页大小改变
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.updateTableData()
    },

    // 当前页改变
    handleCurrentChange(val) {
      this.currentPage = val
      this.updateTableData()
    }
  }
}
</script>

<style scoped>
.postname-rules {
  padding: 5px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.header h2 {
  margin: 0;
  color: #333;
}

.header-buttons {
  display: flex;
  gap: 10px;
}

.table-container {
  margin-bottom: 20px;
}

.condition-cell,
.output-cell {
  padding: 2px;
}

.condition-cell .el-select {
  margin-top: 2px;
}

.output-cell .el-select {
  margin-top: 2px;
}

.pagination-container {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.rules-explanation {
  background: #f5f7fa;
  padding: 20px;
  border-radius: 4px;
  margin-top: 20px;
}

.rules-explanation h3 {
  margin-top: 0;
  color: #333;
}

.rules-explanation ol {
  margin: 10px 0;
  padding-left: 20px;
}

.rules-explanation li {
  margin-bottom: 8px;
  line-height: 1.5;
  color: #666;
}

/* 表格样式优化 */
.el-table .el-table__cell {
  padding: 1px;
}

.el-table .el-input__inner {
  border: none;
  background: transparent;
}

.el-table .el-textarea__inner {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}

.el-table .el-select .el-input__inner {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}
</style> 